import {
  CaseReducerActions,
  createSlice,
  PayloadAction,
  Reducer,
  Slice,
} from '@reduxjs/toolkit';

import { FileMetadataModel } from '../../../shared/models/file-metadata.model';
import { AppsFilesSliceReducers } from '../../models/slices/apps-files-reducers.model';
import { AppsFilesStateModel } from '../../models/slices/apps-files-state.model';

const initialState: AppsFilesStateModel = {
  appsFiles: [],
  icon: null,
  screenshots: [],
  apks: [],
};

export const appsFilesSlice: Slice<
  AppsFilesStateModel,
  AppsFilesSliceReducers,
  string
> = createSlice({
  name: 'appsFiles',
  initialState: initialState,
  reducers: {
    setApk(
      state: AppsFilesStateModel,
      action: PayloadAction<FileMetadataModel>
    ) {
      state.apks = [...state.apks, action.payload.id];
      state.appsFiles = [...state.appsFiles, action.payload];
    },
    setIcon(
      state: AppsFilesStateModel,
      action: PayloadAction<FileMetadataModel>
    ) {
      state.icon = action.payload.id;
    },
    setScreenshots(
      state: AppsFilesStateModel,
      action: PayloadAction<FileMetadataModel>
    ) {
      state.screenshots = [...state.screenshots, action.payload.id];
    },
    deleteApk(state: AppsFilesStateModel, action: PayloadAction<number>) {
      state.apks = state.apks.filter((item, index) => index !== action.payload);
      state.appsFiles = state.appsFiles.filter(
        (item, index) => index !== action.payload
      );
    },
    deleteIcon(state: AppsFilesStateModel) {
      state.icon = null;
    },
    deleteScreenshots(
      state: AppsFilesStateModel,
      action: PayloadAction<number>
    ) {
      state.screenshots = state.screenshots.filter(
        (item, index) => index !== action.payload
      );
    },
    resetAppsFilesState(state: AppsFilesStateModel) {
      Object.assign(state, initialState);
    },
  },
});

export const appsFilesActions: CaseReducerActions<AppsFilesSliceReducers> =
  appsFilesSlice.actions;

const appsFilesSliceReducers: Reducer<AppsFilesStateModel> =
  appsFilesSlice.reducer;

export default appsFilesSliceReducers;
